import * as Scrivito from "scrivito"
import { ScrivitoAttributes } from "shared/types/ScrivitoAttributes"

export const ProductAddonWrapperObjClass = Scrivito.provideObjClass(
  "ProductAddonWrapper",
  {
    attributes: {
      title: "string",
      configurationID: "string",
      addon: ["reference", { only: ["Product", "ProductAddon"] }]
    }
  }
)

export type ProductAddonWrapperObj = InstanceType<
  typeof ProductAddonWrapperObjClass
>
export type ProductAddonWrapperAttributes =
  ScrivitoAttributes<ProductAddonWrapperObj>
